<template>
    <section class="contact-sec">
        <div class="inner">
            <div class="base-box">
                <div class="frame">
                    <h3 class="title text-start">{{ text.eminal }}</h3>
                    <article class="content clearfix">
                        <div class="contact_info">
                            <div class="txt">
                                <a v-bind:href="text.tel" class="tel-event">
                                    <!-- SVGの内容がvue内部のバリデーションに引っかかるためこちらで直書き -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="440" height="59"
                                        viewBox="0 0 298.946 59" v-if="width > 767">
                                        <g id="グループ_1894" data-name="グループ 1894" transform="translate(-50.999 -3)">
                                            <text id="_0120-133-786" data-name="0120-133-786"
                                                transform="translate(222.945 47)" fill="#c3a983" font-size="46"
                                                font-family="DIN2014-Light, 'DIN \32 014'" font-weight="300">
                                                <tspan x="-126.914" y="0">0120-133-786</tspan>
                                            </text>
                                            <g id="グループ_1876" data-name="グループ 1876" transform="translate(0.999 15.719)">
                                                <path id="パス_1743" data-name="パス 1743"
                                                    d="M31.969,25.391,28.81,22.928a4.163,4.163,0,0,0-5.363.21,13.507,13.507,0,0,0-1.459,1.49.358.358,0,0,1-.084.077c-.005,0-.01.009-.015.012a.635.635,0,0,1-.432.054h0c-1.7-.265-6.251-4.364-7.224-5.377-1.157-1.112-6.348-6.906-5.235-7.758a13.471,13.471,0,0,0,1.49-1.459,4.163,4.163,0,0,0,.21-5.363L8.232,1.655a4.137,4.137,0,0,0-.646-.647L7.537.967A4.107,4.107,0,0,0,7.2.723L7.134.684A4.149,4.149,0,0,0,5.9.171h0a4.17,4.17,0,0,0-.45-.077l-.029,0a4.116,4.116,0,0,0-4.33,2.59,12.883,12.883,0,0,0-1.043,5.7c.01.086.037.188.055.281L.106,8.7c.616,3.1,5.354,9.9,8.9,13.827l.139.153c.081.088.164.184.244.269l-.007.005c.173.186,1.1,1.108,1.282,1.282l.005-.007c3.846,3.578,11.032,8.645,14.249,9.284l.043.008c.093.018.195.045.28.055a12.88,12.88,0,0,0,5.7-1.043,4.159,4.159,0,0,0,1.025-7.146Z"
                                                    transform="translate(50 -0.061)" fill="#c3a983" />
                                            </g>
                                        </g>
                                    </svg>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="350" height="77.935"
                                        viewBox="0 0 601.552 77.935" v-else>
                                        <g id="グループ_3579" data-name="グループ 3579" transform="translate(-59.955 -24.683)">
                                            <path id="パス_2940" data-name="パス 2940"
                                                d="M-218.174-46.718c0-11.938-8.366-18.706-18.142-18.706s-18.142,6.768-18.142,18.8v28.388c0,12.032,8.366,18.8,18.142,18.8s18.142-6.768,18.142-18.706Zm-5.452,0v28.576c0,8.46-5.546,13.63-12.69,13.63-7.238,0-12.784-5.17-12.784-13.63V-46.718c0-8.46,5.546-13.63,12.784-13.63C-229.172-60.348-223.626-55.178-223.626-46.718Zm37.694-18.142h-5.452l-9.306,7.144v6.11l9.306-6.674V0h5.452Zm60.16,59.784h-29.8l18.988-22.654c4.982-6.016,11-12.5,11-19.928,0-11.092-8.084-17.766-18.142-17.766-9.964,0-18.142,6.674-18.142,17.39h5.358c.282-8.084,5.828-12.314,12.784-12.314,6.392,0,12.69,4.136,12.69,12.314,0,4.888-2.914,9.4-8.554,16.074L-162.9-4.512V0h37.13Zm45.778-41.642c0-11.938-8.366-18.706-18.142-18.706s-18.142,6.768-18.142,18.8v28.388c0,12.032,8.366,18.8,18.142,18.8S-79.994-6.2-79.994-18.142Zm-5.452,0v28.576c0,8.46-5.546,13.63-12.69,13.63-7.238,0-12.784-5.17-12.784-13.63V-46.718c0-8.46,5.546-13.63,12.784-13.63C-90.992-60.348-85.446-55.178-85.446-46.718Zm13.16,22H-48.88v-4.794H-72.286Zm53.58-40.138h-5.452l-9.306,7.144v6.11l9.306-6.674V0h5.452ZM17.672-30.926h3.572c10.058,0,15.322,5.17,15.322,13.536,0,7.614-5.64,12.878-12.972,12.878C14.57-4.512,10.246-9.494,9.4-16.45H4.042C4.7-6.674,11.468.564,23.594.564c11.186,0,18.424-7.99,18.424-18.142a16.131,16.131,0,0,0-11.374-15.98c5.828-2.162,10.434-6.956,10.434-14.852,0-9.776-7.614-17.014-18.142-17.014-9.494,0-18.048,6.3-18.048,16.544h5.358c.188-6.58,5.358-11.468,12.69-11.468,7.708,0,12.69,5.452,12.69,11.844,0,7.8-4.324,12.5-14.382,12.5H17.672Zm46.06,0H67.3c10.058,0,15.322,5.17,15.322,13.536,0,7.614-5.64,12.878-12.972,12.878-9.024,0-13.348-4.982-14.194-11.938H50.1C50.76-6.674,57.528.564,69.654.564c11.186,0,18.424-7.99,18.424-18.142A16.131,16.131,0,0,0,76.7-33.558c5.828-2.162,10.434-6.956,10.434-14.852,0-9.776-7.614-17.014-18.142-17.014-9.494,0-18.048,6.3-18.048,16.544h5.358c.188-6.58,5.358-11.468,12.69-11.468,7.708,0,12.69,5.452,12.69,11.844,0,7.8-4.324,12.5-14.382,12.5H63.732Zm31.208,6.2h23.406v-4.794H94.94Zm37.036-22.842v-12.22H156.7L135.172,0H141l21.432-59.784V-64.86H126.9v17.3ZM177.1-17.672a13.156,13.156,0,0,1,13.16-13.254,13.216,13.216,0,0,1,13.16,13.254,13.079,13.079,0,0,1-13.16,13.16A13.02,13.02,0,0,1,177.1-17.672Zm.94-30.456a12.136,12.136,0,0,1,12.22-12.22,12.2,12.2,0,0,1,12.22,12.22,12.2,12.2,0,0,1-12.22,12.22A12.136,12.136,0,0,1,178.036-48.128Zm-6.392,30.456c0,10.622,8.648,18.236,18.612,18.236s18.612-7.614,18.612-18.236a17.339,17.339,0,0,0-10.434-15.886,16.359,16.359,0,0,0,9.494-14.57c0-10.058-8.178-17.3-17.672-17.3s-17.672,7.238-17.672,17.3a16.272,16.272,0,0,0,9.4,14.57A17.409,17.409,0,0,0,171.644-17.672Zm65.612-20.116a15.386,15.386,0,0,0-8.272,2.256L241.956-64.86h-6.11L222.4-33.464c-1.974,4.7-4.324,9.87-4.324,14.946,0,11.28,7.614,19.082,18.236,19.082,10.81,0,18.236-7.9,18.236-19.364C254.552-29.8,247.6-37.788,237.256-37.788ZM223.532-18.8c0-8.46,5.076-14.1,12.784-14.1,7.52,0,12.784,5.64,12.784,14.1,0,8.742-5.264,14.288-12.784,14.288C228.608-4.512,223.532-10.058,223.532-18.8Z"
                                                transform="translate(406.955 93)" fill="#c3a983" />
                                            <g id="グループ_1876" data-name="グループ 1876"
                                                transform="translate(69.558 24.683) rotate(8)">
                                                <path id="パス_1743" data-name="パス 1743"
                                                    d="M65.724,52.138,59.23,47.074a8.558,8.558,0,0,0-11.026.432,27.768,27.768,0,0,0-3,3.063.737.737,0,0,1-.172.157c-.011.007-.02.018-.032.024a1.306,1.306,0,0,1-.888.111h-.006c-3.487-.546-12.852-8.972-14.852-11.054-2.379-2.286-13.052-14.2-10.762-15.949a27.7,27.7,0,0,0,3.064-3,8.558,8.558,0,0,0,.431-11.026L16.924,3.338A8.5,8.5,0,0,0,15.6,2.008l-.1-.084a8.444,8.444,0,0,0-.7-.5c-.044-.028-.088-.053-.133-.081A8.529,8.529,0,0,0,12.124.287h0a8.574,8.574,0,0,0-.925-.159L11.136.12a8.463,8.463,0,0,0-8.9,5.325C.982,8.65-.36,13.2.089,17.166c.02.177.077.387.113.579.005.028.011.056.016.085,1.267,6.381,11.008,20.348,18.3,28.427l.285.314c.166.182.338.379.5.554l-.014.011c.356.383,2.252,2.278,2.635,2.635l.011-.015c7.908,7.356,22.682,17.774,29.294,19.088l.089.017c.191.036.4.093.577.113,3.965.449,8.515-.893,11.721-2.144a8.55,8.55,0,0,0,2.107-14.692Z"
                                                    transform="translate(0 -0.061)" fill="#c3a983" />
                                            </g>
                                        </g>
                                    </svg>

                                </a>
                            </div>
                            <div class="small-txt">
                                <div class="time-img">
                                    <span v-html="svg.pcRecip" v-if="width > 767"></span>
                                    <span v-html="svg.spRecip" v-else></span>
                                    <span>&nbsp;{{ text.openTime }}</span><br>
                                </div>
                                <!-- 要素がずれるので矯正 -->
                                <div class="time-img time-img2">
                                    <span v-html="svg.pcClosing" v-if="width > 767"></span>
                                    <span v-html="svg.spClosing" v-else></span>
                                    <span>&nbsp;{{ text.closingDay }}</span>
                                </div>
                                <div class="address d-flex " v-if="width < 767">
                                    <span class="" v-html="svg.pcAddress" v-if="width > 900"></span>
                                    <span class="" v-html="svg.spAddress" v-else></span>
                                    <p class="text-break">{{ text.address }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="address d-flex justify-content-center padding-r" v-if="width > 767">
                            <span class="" v-html="svg.pcAddress" v-if="width > 900"></span>
                            <span class="" v-html="svg.spAddress" v-else></span>
                            <p class="text-break">&nbsp;&nbsp;{{ text.address }}</p>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                text: {
                    eminal: "医療法人社団 エミナル",
                    tel: "tel:0120-133-786",
                    openTime: "10:00-20:15",
                    closingDay: "不定休",
                    address: "〒802-0006 福岡県北九州市小倉北区魚町2丁目3-20 第30エルザビル3F"
                },
                img: {
                    spTelImg: require("@/assets/images/sp/tel_img.png"),
                    pcTelImg: require("@/assets/images/pc/tel_img.png"),
                    spRecipImg: require("@/assets/images/sp/recip_time_img.png"),
                    pcRecipImg: require("@/assets/images/pc/recip_time_img.png"),
                    spClosingDayImg: require("@/assets/images/sp/closing_day_img.png"),
                    pcClosingDayImg: require("@/assets/images/pc/closing_day_img.png"),
                    spAddressImg: require("@/assets/images/sp/address_img.png"),
                    pcAddressImg: require("@/assets/images/pc/address_img.png")
                },
                svg: {
                    pcRecip: '<svg xmlns="http://www.w3.org/2000/svg" width="75" height="20.361" viewBox="0 0 75 20.361"><g id="グループ_3587" data- name="グループ 3587" transform = "translate(-891 -6426.639)" ><rect id="長方形_2848" data-name="長方形 2848" width="75" height="19" rx="9.5" transform="translate(891 6428)" fill="#c3a983"/><text id="受付時間" transform="translate(900.5 6442.639)" fill="#fff" font-size="14" font-family="Noto Sans Japanese, sans-serif"><tspan x="0" y="0">受付時間</tspan></text> </g></svg>',
                    spRecip: '<svg xmlns="http://www.w3.org/2000/svg" width="95" height="40" viewBox="0 0 130 40"><rect id="長方形_2947" data-name="長方形 2947" width = "130" height="40" rx="10" fill="#c3a983" /><text id="受付時間" transform="translate(17.022 28)" fill="#fff" font-size="24" font-family="Noto Sans Japanese, sans-serif"><tspan x="0" y="0">受付時間</tspan></text></svg>',
                    pcClosing: '<svg xmlns="http://www.w3.org/2000/svg" width="75" height="20" viewBox="0 0 75 20"><g id="グループ_3588" data-name="グループ 3588" transform = "translate(-891 -6450)" ><rect id="長方形_2849" data-name="長方形 2849" width="75" height="19" rx="9.5" transform="translate(891 6451)" fill="#c3a983"/><text id="定休日" transform="translate(907.5 6466)" fill="#fff" font-size="14" font-family="Noto Sans Japanese, sans-serif"><tspan x="0" y="0">定休日</tspan></text></g></svg >',
                    spClosing: '<svg xmlns="http://www.w3.org/2000/svg" width="95" height="40" viewBox="0 0 130 40"><rect id="長方形_2948" data-name="長方形 2948" width = "130" height="40" rx="10" fill="#c3a983" /><text id="定休日" transform="translate(29.565 28.439)" fill="#fff" font-size="24" font-family="Noto Sans Japanese, sans-serif"><tspan x="0" y="0">定休日</tspan></text></svg>',
                    pcAddress: '<svg xmlns="http://www.w3.org/2000/svg" width="70" height="20" viewBox="0 0 70 20"><g id="グループ_3921" data-name="グループ 3921" transform = "translate(-569 -6487)" ><rect id="長方形_2850" data-name="長方形 2850" width="67" height="19" rx="9.5" transform="translate(571 6488)" fill="#c3a983"/><text id="_住_所" data-name="　住　所" transform="translate(569 6503)" fill="#fff" font-size="14" font-family="Noto Sans Japanese, sans-serif"><tspan x="0" y="0">　住　所　</tspan></text></g></svg>',
                    spAddress: '<svg xmlns="http://www.w3.org/2000/svg" width="95" height="40" viewBox="0 0 130 40"><g id="グループ_3601" data-name="グループ 3601" transform="translate(-72 -10955)"><rect id="長方形_2949" data-name="長方形 2949" width="130" height="40" rx="10" transform="translate(72 10955)" fill="#c3a983" /><text id="_住_所_" data-name="　住　所　" transform="translate(72 10986)" fill="#fff" font-size="26" font-family="Noto Sans Japanese, sans-serif"><tspan x="0" y="0">　住　所　</tspan></text></g></svg>',
                },
                width: this.$store.state.width,
            }
    },
    mounted: function () {
        window.addEventListener('resize', this.headlineResize)
    },
    methods: {
        headlineResize() {
            this.width = window.outerWidth;
        }
    }
    }
</script>

<style>
    .contact-sec {
        margin-top: 10%;
        background: #F6F6F6;
    }
    .contact-sec .inner {
        padding: 40px 0 50px;
        color: black;
        border-bottom: 3px solid #C3A983;
    }

    .contact-sec .frame {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .base-box {
        position:relative;
        max-width: 1100px;
        margin: 0 auto;
        padding: 0 50px;
    }

    .contact-sec .title {
        font-family: "ヒラギノ角ゴ ProN W3";
        font-weight: 600;
        font-style: normal;
        font-size: 25px;
        text-align: left;
        color: #C3A983;
        white-space: nowrap;
    }

    .content {
        display: flex;
        flex-direction: column;
    }

    .contact_info {
        display: flex;
    }
    .small-txt {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
    }

    .time-img,
    .address {
        vertical-align: middle;
        display: inline-block;
    }

    .time-img span,
    .address p {
        display: inline-block;
        font-family: "source-han-sans-japanese", sans-serif;
        font-size: 14px;
        font-weight: 500;
        font-style: normal;
        line-height: 26px;
        text-align: left;
        color: #707070;
    }

    .time-img:nth-child(2) {
        text-align: left;
    }

    .address-img {
        padding-bottom: 1%;
    }

    .padding-r {
        padding-right: 5%;
    }

    @media screen and (max-width: 900px) {
        .address {
            /* margin-left: -1.5%; */
            margin-top: 3%;
        }

        .address p {
            padding-left: 3%;
        }

        .contact-sec {
            padding: 0;
            width: 100%;
        }

        .contact-sec .frame {
            margin: 0;
            flex-direction: column;
        }

        .contact-sec .title {
            font-weight: 700;
        }

        .contact-sec .inner {
            padding-bottom: 0;
            width: 100%;
            border-bottom: 5px solid #C3A983;
        }

        .content {
            margin: 0;
            margin-bottom: 35px;
        }

        .contact_info {
            display: initial;
        }

        .base-box {
            padding: 0 20px;
        }

        .tel-img {
            width: 100%;
            height: 50px;
            margin-bottom: 5%;
            margin-right: 5%;
        }

        .small-txt {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding-left: 0;
            justify-content: space-around;
            margin: 0 auto;
        }

        .time-img img {
            padding-right: 5px;
            height: 25px;
            width: 60%;
        }

        .time-img {
            display: flex;
            align-items: center;
            gap: 6px;
            justify-content: flex-end;
        }

        .time-img span {
            margin-left: 0;
        }
/*
        .time-img2 img {
            width: 100% !important;
            margin-left: 0%;
        } */

        .address-img {
            display: flex;
            margin-top: 5%;
            padding-bottom: 0;
            gap: 0;
            justify-content: flex-start;
        }

    }

</style>
